import { render, staticRenderFns } from "./ItemAuctionTransport.vue?vue&type=template&id=298c2f8f&"
import script from "./ItemAuctionTransport.vue?vue&type=script&lang=js&"
export * from "./ItemAuctionTransport.vue?vue&type=script&lang=js&"
import style0 from "./ItemAuctionTransport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports